/* eslint-disable react/sort-prop-types */
import React from 'react';

import t from '../../../labels/labelling-utils';
import { MatchStatusType } from '../../../typings/match';
// import { StatisticsIdList } from '../../../typings/statistics';
import { makeClassNames } from '../../../utils/styles';
import IconMatchStatistics from '../../atoms/icons/icon-match-statistics';
import TeamsTabs from '../../molecules/teams-tabs/teams-tabs';
import CourtesyMessage from '../../organisms/courtesy-message/courtesy-message';
import MatchStatisticsTable, { IMatchStatistics } from '../../organisms/match-statistics-table/match-statistics-table';
import ErrorBoundary from '../error-boundary/error-boundary';

import './match-statistics-detail.scss';

export interface IMatchStatisticsData {
  id: string;
  name: string;
  logoUrl: string;
}
export interface IMatchStatisticsDataTeam {
  matchId?: string | number; // FIXME: BE sends this PROP (always? mandatory?)
  home: IMatchStatisticsData;
  away: IMatchStatisticsData;
  status: MatchStatusType;
  matchStatisticsList: IMatchStatistics[];
}
export interface IMatchStatisticsDetail {
  matchStatisticsDetails: IMatchStatisticsDataTeam;
}

const isValidMatchStatisticsList = (matchStatisticsList: IMatchStatistics[]) =>
  Boolean(matchStatisticsList && matchStatisticsList.length);

const backgroundIconFormation = () => <IconMatchStatistics size="xxlarge" color="medium-light" />;

export const getCourtesyMessage = () => (
  <CourtesyMessage text={t('match.statistics.courtesy.message')} backgroundIcon={backgroundIconFormation()} />
);

const classNames = () =>
  makeClassNames({
    matchStatisticsDetail: 'match-statistics-detail',
    tableWrapper: 'match-statistics-detail__table-wrapper',
  });

const MatchStatisticsDetail = ({ matchStatisticsDetails }: IMatchStatisticsDetail) => {
  const cn = classNames();
  return (
    <div className={cn.matchStatisticsDetail}>
      <TeamsTabs
        idHome={matchStatisticsDetails.home.name}
        idAway={matchStatisticsDetails.away.name}
        home={matchStatisticsDetails.home}
        away={matchStatisticsDetails.away}
        roundLabel={t('match.statistics.label.vs')}
        hasInput={false}
      />
      <div className={cn.tableWrapper}>
        <ErrorBoundary
          hasError={!isValidMatchStatisticsList(matchStatisticsDetails.matchStatisticsList)}
          errorComponent={getCourtesyMessage()}
        >
          <MatchStatisticsTable matchStatisticsList={matchStatisticsDetails.matchStatisticsList} />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default MatchStatisticsDetail;
